module.exports = __webpack_public_path__ + "img/violet_041.0d1b51e3.png";